import { useState, useContext } from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useDataTableHandle } from '../DataTable';
import IpaffsRiskCategorisationTable from './IpaffsRiskCategorisationTable';
import IpaffsUpload from './IpaffsUpload';
import { ipaffsLazy } from '../apiCalls';
import Toast from '../Toast/Toast';
import isoDateConverter from '../isoDateConverter';
import { ShowIf } from '../Security/security';
import { StoreContext } from '../Store';
import { useDataTableData } from '../../hooks/useDataTableData';

const IpaffsRiskCategorisation = () => {
  const [paginationLoaded, setPaginationLoaded] = useState(false);
  const [refreshData, setRefreshData] = useState({});
  const [showToast, setShowToast] = useState(false);
  const store = useContext(StoreContext);

  const [newRiskCategory, setNewRiskCategory] = useState(null);
  async function updateData(setPaginationLength, pagination, sortStatus, search, filter) {
    setRefreshData({
      pagination,
      sortStatus,
      search,
      filter,
      setPaginationLength,
    });
  }

  const toastContent = () => {
    return (
      <Toast className="error-toast">
        <Alert style={{ maxWidth: '35rem', backgroundColor: '#E4E3ED' }} show={showToast}>
          <button className="btn-close position-absolute top-0 end-0 p-3" onClick={() => setShowToast(false)} />
          <div className="floating-box-header-newload align-items-center" style={{ margin: '0px 30px', padding: 0 }}>
            <span>{showToast?.toastTitle}</span>
          </div>
          <p style={{ fontSize: '100%', fontWeight: 500 }} className="text-danger">
            {showToast?.toastBody}
          </p>
        </Alert>
      </Toast>
    );
  };

  const dth = useDataTableHandle();

  const { data, lastUpdated } = useDataTableData(dth, refreshData, ipaffsLazy, paginationLoaded);

  return (
    <Container className="container-md">
      {toastContent()}
      <section className="floating-box" style={{ maxWidth: '1600px' }}>
        {newRiskCategory === null ? (
          <IpaffsRiskCategorisationTable
            dth={dth}
            data={data}
            updateData={updateData}
            setPaginationLoaded={setPaginationLoaded}
            persist={store.ipaffsPersist[0]}
            setPersist={store.ipaffsPersist[1]}
            setNewRiskCategory={setNewRiskCategory}
            lastUpdated={isoDateConverter(lastUpdated)}
          />
        ) : (
          <ShowIf
            or={[
              { department: 'OPS', role: 'SUPERUSER' },
              { department: 'QA', role: 'SUPERUSER' },
              { department: 'CMT' },
            ]}
          >
            <IpaffsUpload
              setNewRiskCategory={setNewRiskCategory}
              lastUpdated={isoDateConverter(lastUpdated)}
              setShowToast={setShowToast}
              setRefreshProductsData={updateData}
              dthProducts={dth}
            />
          </ShowIf>
        )}
      </section>
    </Container>
  );
};

export default IpaffsRiskCategorisation;
